// extracted by mini-css-extract-plugin
export default {"wrapper":"chip-module--wrapper--6e5bc"};